import $ from 'jquery';
// Fix for browser (e.g. IE) that does not support mix blend mode
const initFooterNav = () => {
    const contentEasing = 'swing';
    const contentSpeed = 800;
    const contentDelay = 200;
    const landingDelay = 700; // + contentDelay
    const stepDelay = 600;
    const animSpeed = 500;
    const animEasing = 'swing';
    const mainZindex = 999;

    const stepClass = 'jsfn-active-step';
    const closeData = 'footer-nav-bottom';
    const bodyClasses = 'body-classes';

    const $body = $('body');
    const $footer = $('.js-footer-nav');
    const $footerCloseBar = $('.js-footer-nav .js-header');
    const $footerItems = $('.js-footer-nav .js-footer-nav-items');
    const $footerItem = $('.js-footer-nav-item');
    if ($footer.length <= 0) { return; }

    /** Footer Nav
     * show footer nav
     */
    const showFooterNav = () => {
        $footer.animate({ opacity: 1 }, animSpeed, animEasing);
    };

    /** Landing Page
     * show landing content data
     * show footer navigation
     */
    const animateLandingSection = () => {
        // animate content
        const $els = $('.js-page-header-video .js-animate-appear-up').children();

        let delay = landingDelay;
        for (let i = 0; i < $els.length; i += 1) {
            delay += contentDelay;

            $($els[i]).delay(delay)
                .animate({ top: 0, opacity: 1 }, contentSpeed, contentEasing, () => {
                    if (i + 1 === $els.length) {
                        // animate footer nav
                        showFooterNav();
                    }
                });
        }
    };

    /** Steps Back Home
     * show landing page
     */
    const animateBackHome = () => {
        // get screen height
        const screenHeight = $(window).innerHeight();

        $footer.find('.step-up').hide();
        $footer.find('.step-down').removeClass('reverse-icon');
        $footer.removeClass('keep-on-top');
        $body.find('.exit-step-btn').hide();

        // hide footer nav
        $footer.animate({ opacity: 0 }, animSpeed / 2, animEasing, () => {
            // update step nav label and data
            $footerItems.data('step', 0);
            $footerItems.find('span[data-step]').hide();
            $footerItems.find('span[data-step="0"]').show();

            // hide step
            $('.js-step-content')
                .animate({ top: screenHeight }, animSpeed, animEasing)
                // use promise since we have lot of .js-step-content to make sure the callback called once
                .promise().then(() => {
                    // remove active step body class
                    $body.removeClass(stepClass);
                    // show footer nav
                    showFooterNav();
                    $('.js-step-content').removeAttr('style');
                });
        });
    };

    /** Apply Now - Show
     * show apply now section
     */
    const animateShowApplyNow = () => {
        // scroll up current visible area and hide it
        const screenHeight = $(window).innerHeight();
        $('.js-page-header-video, .js-step-content')
            .animate({ top: -screenHeight }, animSpeed, animEasing)
            // use promise since we use multiple element animated to make sure the callback called once
            .promise().then(() => {
                $('.js-page-header-video, .js-step-content').hide();
            });

        // keep original bottom position and body classes
        const footerBottom = $('.js-footer-nav').css('bottom').replace('px', '') * 1;
        $('.js-footer-nav .js-close')
            .data(closeData, footerBottom)
            .data(bodyClasses, $('body').attr('class'));

        // scroll up footer nav and hide
        $footer
            .animate({ bottom: footerBottom + screenHeight }, animSpeed, animEasing, () => {
                $footerItems.hide();
            });

        // hide content
        const $els = $('.js-how-to-apply .js-animate-appear-up, .js-key-dates .js-animate-appear-up').children();
        $els.css({ top: '50px', opacity: 0 });

        // scroll up apply now
        $('.js-how-to-apply')
            .css('top', screenHeight)
            .animate({ top: 0 }, animSpeed, animEasing, () => {
                // animate content
                let delay = landingDelay;
                for (let i = 0; i < $els.length; i += 1) {
                    delay += contentDelay;
                    $($els[i]).delay(delay).animate({ top: 0, opacity: 1 }, contentSpeed, contentEasing);
                }
            });

        // fade in title and close bar
        $footerCloseBar.fadeIn();
    };

    /** Apply Now - Hide
     * show apply now section
     */
    const animateHideApplyNow = () => {
        // scroll down current visible area
        const screenHeight = $(window).innerHeight();
        $('.js-page-header-video, .js-step-content')
            .css('top', -screenHeight)
            .show()
            .animate({ top: 0 }, animSpeed, animEasing);

        // reset now position base on screen height
        const $closeBar = $('.js-footer-nav .js-close');
        const footerBottom = $closeBar.data(closeData);
        $footer.css('bottom', footerBottom + screenHeight);

        // show scroll down footer nav
        $footerItems.show();
        $footer.animate({ bottom: footerBottom }, animSpeed, animEasing, () => {
            $footer.css('bottom', '');
            $body.addClass($closeBar.data(bodyClasses));
        });

        // scroll down apply now
        $('.js-how-to-apply').animate({ top: screenHeight }, animSpeed, animEasing);

        // fade out title and close bar
        $footerCloseBar.fadeOut();
    };

    /** Steps Back
     * show prev steps section
     */
    const animateStepsBack = () => {
        // get next step
        const step = ($footerItems.data('step') || 0) - 1;

        // if below zero, return
        if (step < 0) return;

        // update step data
        $footerItems.data('step', step);

        // find dom element
        const screenHeight = $(window).innerHeight();
        const $step = $(`.js-step-content[data-animate="step-${step + 1}"]`);

        // hide step up if current step is 1 or 0
        $footer.find('.step-down').removeClass('reverse-icon');
        if (step < 2) {
            $footer.find('.step-up').hide();
        } else {
            $footer.find('.step-up').show();
        }

        // Add a special class to footer if we are on step 1 and above to give the footer a higher z-index
        $footer.removeClass('keep-on-top');
        if (step > 0) {
            $footer.addClass('keep-on-top');
        }

        // hide footer nav
        const prevStepFunction = () => {
            // update step nav label
            $footerItems.find(`span[data-step="${step + 1}"]`).hide();
            $footerItems.find(`span[data-step="${step}"]`).show();

            // reset scroll for prev step
            const $prevStep = $step.prev();
            if ($prevStep.hasClass('js-step-content')) {
                $prevStep.addClass('reset-scroll');
            }

            // slide down step content
            if (step > 1) {
                $step.find('.exit-step-btn').show();
            }
            $step.delay(stepDelay)
                .animate({ top: screenHeight }, animSpeed, animEasing, () => {
                    // remove reset class
                    $prevStep.removeClass('reset-scroll');

                    // set default step z index
                    $step.css('zIndex', 1);

                    if (step <= 1) {
                        $step.find('.exit-step-btn').show();
                    }

                    // remove active step class if current is landing page
                    if (step === 0) {
                        $body.removeClass(stepClass);
                    }

                    // show footer nav
                    showFooterNav();
                });
        };
        if (step > 0) {
            prevStepFunction();
        } else {
            $footer.animate({ opacity: 0 }, animSpeed / 2, animEasing, prevStepFunction);
        }
    };

    /** Steps
     * show steps section
     */
    const animateSteps = () => {
        // update step data
        const step = ($footerItems.data('step') || 0) + 1;

        // find dom element
        const screenHeight = $(window).innerHeight();
        const $step = $(`.js-step-content[data-animate="step-${step}"]`);

        // Check if we are on the last step, if so this function is changed to trigger step back instead
        if ($step.length <= 0) {
            animateStepsBack();
            return;
        }

        // update step data
        $footerItems.data('step', step);

        // hide step up if current step is 1 or 0 or if we are up to the final step
        const $hasNextStep = $(`.js-step-content[data-animate="step-${step + 1}"]`);
        $footer.find('.step-down').removeClass('reverse-icon');
        if (step < 2 || $hasNextStep.length <= 0) {
            $footer.find('.step-up').hide();
            if ($hasNextStep.length <= 0) {
                $footer.find('.step-down').addClass('reverse-icon');
            }
        } else {
            $footer.find('.step-up').show();
        }

        // Add a special class to footer if we are on step 1 and above to give the footer a higher z-index
        $footer.removeClass('keep-on-top');
        if (step > 1) {
            $footer.addClass('keep-on-top');
        }

        // hide content
        const $els = $step.find('.js-animate-appear-up').children();
        $els.css({ top: '50px', opacity: 0 });

        // hide footer nav
        const nextStepFunction = () => {
            // if dom element not exist, return to landing
            if ($step.length <= 0) {
                animateBackHome();
                return;
            }

            // if dom element exist show next step
            // update step nav label
            $footerItems.find(`span[data-step="${step - 1}"]`).hide();
            $footerItems.find(`span[data-step="${step}"]`).show();

            // set active step class
            $body.addClass(stepClass);

            // slide up step content
            if (step > 1) {
                $step.find('.exit-step-btn').show();
            }
            $step
                .addClass('reset-scroll') // reset scroll before scroll up
                .delay(stepDelay)
                .css({ top: screenHeight, zIndex: mainZindex + 2 })
                .animate({ top: 0 }, animSpeed, animEasing, () => {
                    // set default step z index
                    $step
                        .removeClass('reset-scroll') // remove class when done scroll up
                        .css('zIndex', mainZindex + 1);

                    if (step <= 1) {
                        $step.find('.exit-step-btn').show();
                    }

                    // animate content
                    let delay = 0;
                    for (let i = 0; i < $els.length; i += 1) {
                        delay += contentDelay;
                        $($els[i]).delay(delay).animate({ top: 0, opacity: 1 }, contentSpeed, contentEasing);
                    }
                    showFooterNav();
                });
        };
        if (step > 1) {
            nextStepFunction();
        } else {
            $footer.animate({ opacity: 0 }, animSpeed / 2, animEasing, nextStepFunction);
        }
    };

    // activated animation
    animateLandingSection();

    // bind on click close apply
    $('.js-footer-nav .js-close').click(e => {
        e.preventDefault();
        animateHideApplyNow();
    });

    // bind onclick footer nav
    $footerItem.click(function (e) {
        e.preventDefault();

        const $el = $(this);

        // handle apply
        if ($el.data('type') === 'apply') {
            animateShowApplyNow();
        }

        // handle step
        if ($el.data('type') === 'step') {
            animateSteps();
        }

        // handle step back
        if ($el.data('type') === 'step-back') {
            animateStepsBack();
        }

        // handle step back
        if ($el.data('type') === 'back-home') {
            animateBackHome();
        }
    });
};

// doc ready
$(() => {
    initFooterNav();
});



// WEBPACK FOOTER //
// ./src/sections/footer-nav/s-footer-nav.js